import React, { useState, useEffect } from 'react'
import API from '../../utils/API';
import { FormattedMessage, useIntl } from 'react-intl';
import { Form } from 'react-router-dom';
import TrashIcon from '../../assets/icons/table/trash.svg';
import './UserModals.css';

function ImportModal(props) {
	const {
		setResetImportModalRef,
		setSuccess,
		modalError, setModalError,
		ImportLoadData,
		closeModal,
	} = props;

	  // Import modal states
		const [selectedFile, setSelectedFile] = useState(null);
		const [fileName, setFileName] = useState('');
		const [failingRows, setFailingRows] = useState([]);
		const [successfulRows, setSuccessfulRows] = useState([]);
		const [duplicateRows, setDuplicateRows] = useState([]);

	const intl = useIntl();

	const chooseFileText = intl.formatMessage({ id: 'CHOOSE_FILE' });

	useEffect(() => {
    setResetImportModalRef(resetModal);
  }, [setResetImportModalRef]);

	const resetModal = () => {
		setDuplicateRows([]);
    setFailingRows([]);
    setSuccessfulRows([]);
		setSelectedFile(null);
		setFileName('');
		setModalError('');
	};

	function handleFileSelection(file) {
		if (file === undefined) return;
		setSelectedFile(file);
		setFileName(file.name);
	}

	function removeFile(e) {
		e.stopPropagation();
		setSelectedFile(null);
		setFileName('');
		setModalError('');
	}

	function openFileDialog(e) {
		e.stopPropagation();
		document.getElementById('userFormFile').click();
	}

	function handleUpload() {
		console.log("selectedFile", selectedFile)
		// Check that a file is selected and that it has a `.csv` extension
		if (selectedFile) {
			const fileName = selectedFile.name;
			const fileExtension = fileName.split('.').pop().toLowerCase(); // Get file extension

			if (fileExtension === 'csv') {
					// Proceed with file upload if the extension is correct
					API.importUsers(selectedFile)
							.then((res) => {
									console.log("res", res.data);
									setFailingRows(res.data.failingRows);
									setSuccessfulRows(res.data.successfulRows);
									setDuplicateRows(res.data.duplicateRows);
									ImportLoadData();
									closeModal("import-modal");
									setSuccess(
											<FormattedMessage
													id="IMPORT_USERS_SUCCESS"
													values={{
															successfulCount: res.data.successfulRows.length,
															failingCount: res.data.failingRows.length,
															duplicateCount: res.data.duplicateRows.length
													}}
											/>
									);
							})
							.catch((err) => {
									setModalError(<FormattedMessage id="IMPORT_USERS_FAILED" />);
									console.error(err);
							});
				} else {
						// Set modal error if the file extension isn't `.csv`
						setModalError(<FormattedMessage id="INVALID_FILE_EXTENSION" values={{ extension: fileExtension }} />);
				}
		} else {
				// Set modal error if no file is selected
				setModalError(<FormattedMessage id="PLEASE_SELECT_FILE" />);
		}
	}

	function handleDrop(e) {
		e.preventDefault();
		const file = e.dataTransfer.files[0]; // Assuming single file drop, adjust as necessary
		handleFileSelection(file);
	}

	return (
		<div className="modal fade" id="importUsersModal" tabIndex="-1" aria-labelledby="importModalLabel" aria-hidden="true">
			<div className="modal-dialog modal-dialog-centered">
				<div className="modal-content">
					<div className="modal-header">
						<h5 className="modal-title"><FormattedMessage id="IMPORT_USERS" /></h5>
						<button id="closeImportModal" type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
					</div>
					<div className="modal-body">
						<div className="modal-subtitle"><FormattedMessage id="UPLOAD_A_CSV" /></div>
						<div className={`mb-3 drop-zone ${selectedFile ? 'active' : ''}`}
							onClick={() => document.getElementById('userFormFile').click()}
							onDragOver={(e) => e.preventDefault()}
							onDrop={(handleDrop)}>
							{selectedFile ? (
								<div className="file-info">
									<div className="file-details">
										<span className="file-name">{fileName}</span>
										<span className="file-size">{(selectedFile.size / 1024).toFixed(2)} KB</span>
									</div>
									<img id="removeBtn" src={TrashIcon} alt="Trash Icon" onClick={removeFile} className="trash-icon" />
								</div>
							) : (
								<div>
									<FormattedMessage
										id="DRAG_AND_DROP_OR_CHOOSE_FILE"
										values={{ chooseFile: <span style={{ color: '#FF4500', textDecoration: 'underline', cursor: 'pointer' }} onClick={openFileDialog}>{chooseFileText}</span> }}
									/>
								</div>
							)}
							<input className="form-control" type="file" id="userFormFile" onChange={(e) => handleFileSelection(e.target.files[0])} style={{ display: 'none' }} />
						</div>
						<div className="csv-template mb-3">
							<div className="template-details">
								<div className="template-title"><FormattedMessage id="CSV_TEMPLATE" /></div>
								<div className="template-description"><FormattedMessage id="CSV_TEMPLATE_DESCRIPTION" /></div>
							</div>
							<div className="template-link">
								<a id="downloadBtn" className="btn download-btn" href="/templates/usersTemplate.csv" download="template.csv"><FormattedMessage id="DOWNLOAD" /></a>
							</div>
						</div>
						{modalError && (
							<div className="modal-error invalid-feedback d-block fw-bold text-center">
								{modalError}
							</div>
						)}
					</div>
					<div className="modal-footer justify-content-between">
						<button id="backBtn" type="button" className="btn back-btn" data-bs-dismiss="modal"><FormattedMessage id="CLOSE" /></button>
						<button id="importUsersBtn" type="button" className="btn modal-btn save-btn" onClick={handleUpload}><FormattedMessage id="IMPORT" /></button>
					</div>
				</div>
			</div>
		</div>
	);
}

export default ImportModal